import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Truck, Instagram, Facebook, Menu, X, MessageCircle } from "lucide-react";
import { BRAND, NAV_LINKS, waLink } from "@/lib/brand";

const TopBar = () => (
  <div className="bg-choco text-cream/80 text-xs">
    <div className="mx-auto max-w-[1400px] px-5 py-2 flex items-center justify-between">
      <div className="flex items-center gap-6">
        <a href={waLink()} className="flex items-center gap-2 hover:text-cream transition-colors" data-testid="topbar-phone">
          <Phone size={13} className="text-gold" /> {BRAND.phoneDisplay}
        </a>
        <span className="hidden sm:flex items-center gap-2">
          <Truck size={14} className="text-gold" /> Encomendas com praticidade e carinho
        </span>
      </div>
      <div className="flex items-center gap-4">
        <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-gold transition-colors"><Instagram size={15} /></a>
        <a href={BRAND.instagramUrl} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-gold transition-colors"><Facebook size={15} /></a>
      </div>
    </div>
  </div>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      <TopBar />
      <div className={`transition-all duration-300 border-b ${scrolled ? "bg-cream/95 backdrop-blur-md border-beige py-2 shadow-sm" : "bg-cream border-transparent py-3"}`}>
        <div className="mx-auto max-w-[1400px] px-5 flex items-center justify-between gap-6">
          <a href="#inicio" className="flex items-center" data-testid="header-logo">
            <img src={BRAND.logo} alt="Deco Sweet" className={`transition-all duration-300 ${scrolled ? "h-12" : "h-16"} w-auto object-contain`} />
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_LINKS.map((l) => (
              <a key={l.label} href={l.href} data-testid={`nav-${l.label}`}
                 className="relative text-[13px] font-medium tracking-wide uppercase text-choco/80 hover:text-choco transition-colors after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-gold hover:after:w-full after:transition-all after:duration-300">
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a href={waLink()} data-testid="header-cta-whatsapp"
               className="hidden sm:inline-flex items-center gap-2 rounded-full bg-choco text-cream px-6 py-3 text-xs font-semibold uppercase tracking-widest hover:bg-gold transition-colors duration-300">
              <MessageCircle size={16} /> Fale Conosco
            </a>
            <button className="lg:hidden text-choco" onClick={() => setOpen(true)} aria-label="Abrir menu" data-testid="mobile-menu-open">
              <Menu size={26} />
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div className="fixed inset-0 z-[60] bg-choco text-cream lg:hidden"
            initial={{ opacity: 0, x: "100%" }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: "100%" }}
            transition={{ type: "tween", duration: 0.35 }}>
            <div className="flex items-center justify-between px-5 py-4 border-b border-cream/15">
              <img src={BRAND.logo} alt="Deco Sweet" className="h-14 w-auto invert-0 brightness-0 opacity-0 hidden" />
              <span className="font-script text-3xl text-gold">Deco Sweet</span>
              <button onClick={() => setOpen(false)} aria-label="Fechar menu" data-testid="mobile-menu-close"><X size={28} /></button>
            </div>
            <nav className="flex flex-col px-6 py-8 gap-6">
              {NAV_LINKS.map((l) => (
                <a key={l.label} href={l.href} onClick={() => setOpen(false)}
                   className="font-serif text-3xl text-cream/90 hover:text-gold transition-colors">{l.label}</a>
              ))}
              <a href={waLink()} className="mt-4 inline-flex items-center gap-2 rounded-full bg-gold text-choco px-6 py-3 text-sm font-semibold uppercase tracking-widest w-fit">
                <MessageCircle size={18} /> Fale Conosco
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
